var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 175V158.333C25 149.493 28.5119 141.014 34.7631 134.763C41.0143 128.512 49.4928 125 58.3333 125H91.6667C100.507 125 108.986 128.512 115.237 134.763C121.488 141.014 125 149.493 125 158.333V175M133.333 26.0834C140.503 27.9192 146.859 32.0892 151.397 37.936C155.935 43.7827 158.399 50.9736 158.399 58.375C158.399 65.7765 155.935 72.9674 151.397 78.8141C146.859 84.6609 140.503 88.8309 133.333 90.6667M175 175V158.334C174.958 150.977 172.483 143.84 167.961 138.037C163.439 132.234 157.124 128.089 150 126.25M41.6667 58.3333C41.6667 67.1739 45.1786 75.6524 51.4298 81.9036C57.681 88.1548 66.1594 91.6667 75 91.6667C83.8405 91.6667 92.319 88.1548 98.5702 81.9036C104.821 75.6524 108.333 67.1739 108.333 58.3333C108.333 49.4928 104.821 41.0143 98.5702 34.7631C92.319 28.5119 83.8405 25 75 25C66.1594 25 57.681 28.5119 51.4298 34.7631C45.1786 41.0143 41.6667 49.4928 41.6667 58.3333Z",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonal);
export default __webpack_public_path__ + "static/media/Personal.937ef06c83b7d56ffe281ebf5af4135f.svg";
export { ForwardRef as ReactComponent };